import React, { useRef } from "react";
import { DialogTitle, Dialog, DialogContent, DialogActions } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { CloseIcon } from "@icarius-icons";
import paths from "@icarius-router/paths";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import CommonPage from "@icarius-common/commonPage";
import { useDispatch } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";

const StyledDialog = withStyles({
  paper: {
    maxHeight: "95%",
    minHeight: "85%",
    maxWidth: "95%",
    minWidth: "85%",
  },
})(Dialog);

const SecondGridDialogIsOpen = (props) => {

  const {
    open,
    data,
    dateFormat,
    locale,
    isDataReplicateDisabled,
    handleConfirm,
    handleClose,
  } = props;

  const ownGridRef = useRef();
  const dispatch = useDispatch();

  const submit = (replicate) => {
    if (ownGridRef.current) {
      let selectedRows = ownGridRef.current.api.getSelectedRows();

      // Si no hay seleccionado, pido seleccionar
      if (selectedRows.length === 0) {
        dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectAtLeastOneRow"), severity: "warning" }));
        return;
      }

      const colabCodes = selectedRows.map(row => row["CODIGO DE EMPLEADO"])
      handleConfirm(colabCodes, replicate);
      handleClose();
    }
  };

  return (
    <StyledDialog
      open={open}
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      scroll={"paper"}
      maxWidth={"md"}
      fullWidth
    >
      <DialogTitle style={{ cursor: 'move', paddingBottom: 0 }} id="draggable-dialog-title">
        {getLocalizedString("addCollaboratorList")}
      </DialogTitle>
      <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
      <DialogContent>
        <CommonPage
          ownGridRef={ownGridRef}
          gridTitle={getLocalizedString("collaboratorList")}
          columnDefPage={paths.myPeople}
          rowData={data}
          dateFormat={dateFormat}
          locale={locale}
          gridHeight={'70vh'}
          ignoreProcessesbyPath
        />
      </DialogContent>
      <DialogActions>
        <ButtonDialogAction onClick={handleClose} text={getLocalizedString("close")} />
        <ButtonDialogAction onClick={() => submit(false)} isAccept text={getLocalizedString("addEmployees")} />
        <ButtonDialogAction disabled={isDataReplicateDisabled} onClick={() => submit(true)} isAccept text={getLocalizedString("addWithDataReplica")} />
      </DialogActions>
    </StyledDialog>
  );
}

export default SecondGridDialogIsOpen;